import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  emailVerification,
  fetchProfileData,
  updateProfileData,
} from "./ProfileApi";
import { ProfileDataState } from "../../../features/view/private/profilePage/components/ProfilePageTypes";

const initialState: ProfileDataState = {
  isValidUser: false,
  profileData: { data: {}, loader: false },
  updateLoader: false,
  emailVerificationLoader: false,
};

export const getProfileDataAsync = createAsyncThunk("profile/get", async () => {
  const response = await fetchProfileData();
  return response;
});
export const updateProfileDataAsync = createAsyncThunk(
  "profile/update",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await updateProfileData(payload);
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);
export const emailVarificationAsync = createAsyncThunk(
  "profile/email/verification",
  async (_, { rejectWithValue }) => {
    try {
      const response = await emailVerification();
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const ProfileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setUserDetails: (state, action) => {
      state.profileData.data = action.payload;
    },
    setValidUser: (state, action) => {
      state.isValidUser = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getProfileDataAsync.pending, (state) => {
        state.profileData.loader = true;
      })
      .addCase(getProfileDataAsync.fulfilled, (state, action: any) => {
        state.profileData.loader = false;
        state.profileData.data = action?.payload?.data?.data || [];
      })
      .addCase(getProfileDataAsync.rejected, (state) => {
        state.profileData.loader = false;
      })
      .addCase(updateProfileDataAsync.pending, (state) => {
        state.updateLoader = true;
      })
      .addCase(updateProfileDataAsync.fulfilled, (state, action: any) => {
        state.updateLoader = false;
      })
      .addCase(updateProfileDataAsync.rejected, (state, action: any) => {
        state.updateLoader = false;
      })
      .addCase(emailVarificationAsync.pending, (state) => {
        state.emailVerificationLoader = true;
      })
      .addCase(emailVarificationAsync.fulfilled, (state) => {
        state.emailVerificationLoader = false;
      })
      .addCase(emailVarificationAsync.rejected, (state) => {
        state.emailVerificationLoader = false;
      });
  },
});
export const { setUserDetails, setValidUser } = ProfileSlice.actions;

export default ProfileSlice.reducer;
